import {StringValidacao} from './string';
import {Construtor} from './construtor';
import {CriterioAvaliacao} from './criterio-avaliacao';

export class CriterioAvaliacaoRotinaCliente implements Construtor<CriterioAvaliacaoRotinaCliente> {

  public idCriterioAvaliacaoRotinaCliente: number;
  public idRotinaCliente: number;
  public criterioAvaliacao: CriterioAvaliacao;
  public descricaoCriterioAvaliacaoRotina: string;
  public indicadorObrigaFotoCriterio: boolean;

  constructor(object?: any) {
    this.indicadorObrigaFotoCriterio = false;
    this.criterioAvaliacao = new CriterioAvaliacao();

    if (object !== undefined) {

      if (object instanceof CriterioAvaliacaoRotinaCliente) {
        this.copyObject(object);
      } else if (object instanceof CriterioAvaliacao) {
        this.criterioAvaliacao = new CriterioAvaliacao(object);
      } else {
        this.parseFromJson(object);
      }

      return this.modeloCompleto() ? this : null;
    }

    return this;
  }

  get obterIdCriterioAvaliacaoRotinaCliente(): number {
    return this.idCriterioAvaliacaoRotinaCliente;
  }

  set IdCriterioAvaliacaoRotinaCliente(idCriterioAvaliacao: any) {
    this.idCriterioAvaliacaoRotinaCliente = idCriterioAvaliacao;
  }

  get obterIdRotinaCliente(): number {
    return this.idRotinaCliente;
  }

  set IdRotinaCliente(idRotinaCliente: any) {
    this.idRotinaCliente = idRotinaCliente;
  }

  get obterCriterioAvaliacao(): CriterioAvaliacao {
    return this.criterioAvaliacao;
  }

  set CriterioAvaliacao(criterioAvaliacao: any) {
    this.criterioAvaliacao = criterioAvaliacao;
  }

  get obterDescricaoCriterioAvaliacaoRotina(): string {
    return this.descricaoCriterioAvaliacaoRotina.slice(0);
  }

  set DescricaoCriterioAvaliacaoRotina(nomeCriterioAvaliacao: any) {
    this.descricaoCriterioAvaliacaoRotina = StringValidacao.copiarStringValida(nomeCriterioAvaliacao);
  }

  get obterIndicadorObrigaFotoCriterio(): boolean {
    return this.indicadorObrigaFotoCriterio;
  }

  set IndicadorObrigaFotoCriterio(indicadorObrigaFotoCriterio: any) {
    this.indicadorObrigaFotoCriterio = indicadorObrigaFotoCriterio;
  }

  copyObject(criterio: CriterioAvaliacaoRotinaCliente): void {
    this.idCriterioAvaliacaoRotinaCliente = criterio.obterIdCriterioAvaliacaoRotinaCliente;
    this.descricaoCriterioAvaliacaoRotina = criterio.obterDescricaoCriterioAvaliacaoRotina;
    this.criterioAvaliacao = criterio.obterCriterioAvaliacao;
    this.indicadorObrigaFotoCriterio = criterio.obterIndicadorObrigaFotoCriterio;
    this.idRotinaCliente = criterio.obterIdRotinaCliente;
  }

  parseFromJson(criterio: any): void {
    this.IdCriterioAvaliacaoRotinaCliente = criterio.idCriterioAvaliacaoRotinaCliente;
    this.DescricaoCriterioAvaliacaoRotina = criterio.descricaoCriterioAvaliacaoRotina;
    this.CriterioAvaliacao = criterio.criterioAvaliacao;
    this.IndicadorObrigaFotoCriterio = criterio.indicadorObrigaFotoCriterio;
    this.IdRotinaCliente = criterio.idRotinaCliente;

  }

  modeloCompleto(): boolean {
    return this.descricaoCriterioAvaliacaoRotina !== undefined;
  }

  getNewInstance(object?: any): CriterioAvaliacaoRotinaCliente {
    return new CriterioAvaliacaoRotinaCliente(object);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/criterio-avaliacao-rotina-cliente.ts